import React, {
    useCallback,
    useEffect,
    useMemo,
    useRef,
    useState,
  } from "react";
  import "./CustomerDropdown.css";
  
  interface Props {
    maxLength?: number;
    type: string;
    register: any;
    placeholder?: string;
    name: string;
    required?: boolean | string;
    pattern?: RegExp;
    message?: string;
    errors: any;
    dataList: any;
    setValue: any;
    setIsCountry: any;
    isDisabled: any;
    setData: any;
    setState: any;
    setCity: any;
    selectedOption: string;
    getValues: any;
  }
  
  const CustomerDropdown: React.FC<Props> = ({
    maxLength,
    type,
    register,
    placeholder,
    name,
    required,
    pattern,
    message,
    errors,
    dataList,
    setValue,
    setIsCountry,
    isDisabled,
    setData,
    setState,
    setCity,
    selectedOption,
    getValues,
  }) => {
    const dropdownRef: any = useRef(null);
  
    const [isOpen, setIsOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState(dataList);
    const [selected, setSelected] = useState<any>(null);
    const [isSearching, setIsSearching] = useState(false);
    const [searchText, setSearchText] = useState("");
  
    useEffect(() => {
      setSearchTerm(dataList);
    }, [dataList]);
  
    // Filter items based on search term
    const searchHandler = (searchText: any) => {
      setIsSearching(true);
      setSearchText(searchText);
      const filteredData = searchText
        ? dataList.filter((item: any) =>
            item.label.toLowerCase().includes(searchText.toLowerCase())
          )
        : dataList;
      setSearchTerm(filteredData);
    };
  
    const handleOptionSelect = (data: any) => {
      setSelected(data.label);
      setIsOpen(false);
      setSearchText("");
      if (selectedOption === "country") {
        setValue("state", undefined);
        setValue("city", undefined);
        setCity('');
        setState('');
        setIsCountry(true);
      } else if (selectedOption === "state") {
        setValue("city", undefined);
        setCity('');
      }
      setValue(name, data.label, { shouldValidate: true });
      // data.label !== "India" && setData(data);
      setData(data);
      // data.label === "India" && setIsCountry(true);
      
    };
  
    const handleBlur = () => {
      setTimeout(() => setIsOpen(false), 200); // Delay closing
    };
  
    // Close dropdown when clicking outside
    useEffect(() => {
      function handleClickOutside(event: any) {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
          setIsOpen(false);
          setIsSearching(false);
        }
      }
      document.addEventListener("mousedown", handleClickOutside);
      return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);
  
    return (
      <div className="custom-outer">
        <div className="custom-email-form">
          <input
            onFocus={() => setIsOpen(true)}
            maxLength={maxLength}
            type={type}
            placeholder={placeholder}
            {...register(name, {
              required: required ? message : false,
              pattern: pattern ? { value: pattern, message } : undefined,
              // onBlur: () => handleBlur(''),
            })}
            autoComplete="off"
            value={selected?.label}
            disabled={isDisabled}
          />
        </div>
        {errors?.[name] && (
          <p className="custom-error">{errors[name]?.message}</p>
        )}
  
        {isOpen && (
          <div className="dropdown-container" ref={dropdownRef}>
            <div>
              <input
                autoFocus
                value={searchText}
                onBlur={() => handleBlur()}
                onChange={(e) => searchHandler(e.target.value)}
                className="custom-search"
                placeholder="Search"
              />
              {searchTerm.map((ele: any) => (
                <p key={ele.label} onClick={() => handleOptionSelect(ele)}>
                  {ele.label}
                </p>
              ))}
            </div>
          </div>
        )}
      </div>
    );
  };
  
  export default CustomerDropdown;
  